import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getMediaWiseImages } from "../../../../redux/Parent/class/action";
import BackButton from '../../../../elements/BackButton'
import img from '../../../../assets/Images/nophoto.png'
import SingleMedia from './SingleMedia';
export class MediaImages extends Component {
    state = {
        image: '',
        open: false,
        id: this.props.match.params,
    }
    componentDidMount() {
        this.setState({ loading: true });
        const { user, mediaimages } = this.props;
        this.props.getMediaWiseImages(user?.data?.auth_token, this.state.id);
        setTimeout(() => {
            this.setState({ loading: false });
        }, 1500);
    }
    openViewer = () => {
        this.setState({ open: !this.state.open })
    }
    render() {
        const { mediaimages } = this.props;
        return (
            <React.Fragment>
                <BackButton title={"Gallery"} />
                {mediaimages?.data?.length > 0 ?
                    <div className="d-flex justify-content-between flex-wrap mx-3 mt-4" >
                        {mediaimages?.data?.length > 0 && mediaimages?.data?.map((data) => (
                            <SingleMedia media={data} />
                        ))}
                    </div>
                    :
                    <div className='mt-5 pt-5 w-100 d-flex flex-column justify-content-center align-items-center'>
                        <img src={img} alt="no photo" style={{ width: '65vw' }} className='' />
                        <span>No Images Found...</span>
                    </div>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.user.parent,
    mediaimages: state.class.mediaimages,
})

export default connect(mapStateToProps, { getMediaWiseImages })(MediaImages)
